import React from "react";
import { useTranslation } from "react-i18next";

const AppBreadcrumb = ({
    title,
    children,
    rowClassName = "",
    titleColClassName = "col-md-6 col-sm-12",
    ...props
}) => {
    const { t } = useTranslation();
    const rowClasses = ["row", "clearfix", rowClassName].filter(Boolean).join(" ");
    return (
        <div className="block-header">
            <div className={rowClasses}>
                <div className={titleColClassName}>
                    <h2>{process.env.REACT_APP_APP_NAME}</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active" aria-current="page">{typeof title === 'string' ? t(title) : title}</li>
                        </ol>
                    </nav>
                </div>
                {children}
            </div>
        </div>
    )
}

export default AppBreadcrumb;